import { getCountryCodeFromLocale, isNumeric } from 'app/functions/string';
import { mapAutocompleteResponse } from 'app/functions/api';

export type AutocompleteRequestArgs = {
  autocompleteUrl: string;
  query: string;
  locale: string;
  flixbusCitiesOnly: boolean;
  departureCity: string | number | null;
  isFlixTrainDomain: boolean;
  showStationSuggestions: boolean;
  popularStationsCount: number | null;
  additionalHeaders?: Record<string, string>;
};

export const fetchAutocompleteResults = ({
  autocompleteUrl,
  query,
  locale,
  flixbusCitiesOnly,
  departureCity = null,
  showStationSuggestions,
  popularStationsCount,
  isFlixTrainDomain,
  additionalHeaders = {},
}: AutocompleteRequestArgs) => {
  const params = [
    `q=${query}`,
    `lang=${locale}`,
    `country=${getCountryCodeFromLocale(locale)}`,
    `flixbus_cities_only=${flixbusCitiesOnly}`,
    `is_train_only=${isFlixTrainDomain}`,
    `stations=${showStationSuggestions}`,
    `${showStationSuggestions ? 'popular_stations=true' : ''}`,
    `popular_stations_count=${popularStationsCount}`,
  ];

  const options: { headers?: Record<string, string> } = {};

  Object.entries(additionalHeaders).forEach((header) => {
    options.headers = {
      ...(options.headers || {}),
      [header[0]]: [header[1]].toString(),
    };
  });

  // only send if its a UUID
  if (departureCity && !isNumeric(departureCity)) {
    params.push(`departure_city=${departureCity}`);
  }

  return fetch(`${autocompleteUrl}?${params.join('&')}`, options)
    .then((response) => response.json())
    .then((jsonResponse) => mapAutocompleteResponse(jsonResponse));
};
